type StoredFilters = {
  company?: string;
  brand?: string;
  state?: string;
  metric?: string;
  customerClass?: string;
  windowRange?: [string, string];
  compareRange?: [string, string];
};

export type SharedComplaintFilters = {
  company?: string;
  brand?: string;
  state?: string;
  metric?: string;
  customerClass?: string;
  windowRange?: Date[];
  compareRange?: Date[];
};

const STORAGE_KEY = 'complaints.shared.filters.v1';

const toIsoMonth = (value: Date) => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-01`;
const parseIso = (value?: string) => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), 1);
};

export const loadSharedComplaintFilters = (): SharedComplaintFilters => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as StoredFilters;
    const windowFrom = parseIso(parsed.windowRange?.[0]);
    const windowTo = parseIso(parsed.windowRange?.[1]);
    const compareFrom = parseIso(parsed.compareRange?.[0]);
    const compareTo = parseIso(parsed.compareRange?.[1]);

    return {
      company: parsed.company,
      brand: parsed.brand,
      state: parsed.state,
      metric: parsed.metric,
      customerClass: parsed.customerClass,
      windowRange: windowFrom && windowTo ? [windowFrom, windowTo] : undefined,
      compareRange: compareFrom && compareTo ? [compareFrom, compareTo] : undefined,
    };
  } catch {
    return {};
  }
};

export const saveSharedComplaintFilters = (filters: SharedComplaintFilters) => {
  try {
    const payload: StoredFilters = {
      company: filters.company,
      brand: filters.brand,
      state: filters.state,
      metric: filters.metric,
      customerClass: filters.customerClass,
      windowRange: filters.windowRange ? [toIsoMonth(filters.windowRange[0]), toIsoMonth(filters.windowRange[1])] : undefined,
      compareRange: filters.compareRange ? [toIsoMonth(filters.compareRange[0]), toIsoMonth(filters.compareRange[1])] : undefined,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore persistence errors
  }
};
